import useAnalytics from "@hsl/core/hooks/useYardAnalyticsEvents";

import Checkbox from "../Checkbox";
import { type Props as TooltipProps } from "../Tooltip/Tooltip";
import CheckboxListContainer from "./components/CheckboxListContainer";

export interface Props<V> {
    containerClassName?: string;
    isOpen?: boolean;
    options: { label: string; value: V; disabled?: boolean }[];
    title: React.ReactNode;
    label: string;
    tooltip?: TooltipProps;
    values?: V[];
    onChange?: (output: V[]) => void;
}

const CheckboxList = <V,>({
    containerClassName,
    options = [],
    isOpen,
    title,
    label,
    tooltip,
    values = [],
    onChange,
}: Props<V>) => {
    const { filterEvent } = useAnalytics();
    const handleCheckboxChange = (val: V, checked: boolean) => {
        filterEvent(checked ? "add" : "remove", label, val as string);
        const newSelection = checked
            ? [...values, val]
            : values.filter((x) => {
                  return Array.isArray(val) ? !val.includes(x) : x !== val;
              });
        onChange && onChange(newSelection);
    };

    const isSelected = (val: V) => {
        if (Array.isArray(val)) {
            return values.some((x) => val.includes(x));
        }
        return values.includes(val);
    };

    return (
        <CheckboxListContainer
            title={title}
            isOpen={isOpen}
            tooltip={tooltip}
            containerClassName={containerClassName}
        >
            {options.map((item, i) => (
                <Checkbox<V>
                    key={`${title}-${i}`}
                    label={item.label}
                    value={item.value}
                    selected={isSelected(item.value)}
                    onChange={handleCheckboxChange}
                    disabled={item.disabled}
                    labelClassName="text-sm"
                />
            ))}
        </CheckboxListContainer>
    );
};

export default CheckboxList;
